module.exports = __webpack_public_path__ + "static/Abbotsford8_dark-c3f7fe2a4bee5dad269b2aeab9959c9c.jpg";